import { COUNTRY_LIST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const countryListRequest = () => ({
  url: COUNTRY_LIST,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false, // Set to true if your standard requests require auth tokens
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const createCountry = (payload) => ({
  url: COUNTRY_LIST,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload, // The payload contains { countryName, regionIds } as sent from CountryList.js
  service: serviceName.MASTER_MS,
});

export const updateCountry = (payload) => ({
  url: COUNTRY_LIST,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload, // The payload contains { countryId, countryName, regionIds } for edits, or { mappingId, isActive } for toggles
  service: serviceName.MASTER_MS,
});
